//@ts-ignore
import "admin-lte/plugins/bootstrap/js/bootstrap.bundle";
import "admin-lte/plugins/jquery-ui/jquery-ui";
import "admin-lte/plugins/jquery/jquery";
import "admin-lte/plugins/popper/popper";
import jQuery from "jquery";
import ConfirmationService from 'primevue/confirmationservice';

import "@fortawesome/fontawesome-free/css/all.css";
import "primeicons/primeicons.css";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/bootstrap4-light-purple/theme.css";

import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte";
import "admin-lte/plugins/icheck-bootstrap/";
import "toastr/build/toastr.min.css";

import "@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css";
import "select2/dist/css/select2.min.css";
import "select2/dist/js/select2.full.min";

import "./assets/css/main.css";

import "select2";

import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";

import App from "./App.vue";

import { router } from "./configs/router";
//@ts-ignore
import moment from "moment";
import "moment/locale/pt-br";

import Modal from "pedrociarlini-components/src/components/shared/modal/Modal.vue";
import VueCookie from "vue-cookies";
//@ts-ignore
import { Component as Vuedal, default as Vuedals, Bus as VuedalsBus } from "vuedals";

import primeVueConfig from "./configs/primeVueConfig";

//@ts-ignore
import URLS from "frontend-domain/src/domain/UrlsVO";
import PrimeVue from "primevue/config";

//@ts-ignore
import Tooltip from "primevue/tooltip";

Vue.use(PrimeVue, primeVueConfig);
Vue.directive("tooltip", Tooltip);

Object.defineProperty(Vue.prototype, "$jQuery", { value: jQuery });
jQuery.fn.select2.defaults.set("theme", "bootstrap4");

Vue.use(VueCookie, { expires: "7d", domain: `.${URLS.dominio}`, path: "/" });

Vue.use(Vuedals);

Vue.component("modal", Modal);
Vue.component("vuedal", Vuedal);

const realFormater = Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
});
const percFormater = Intl.NumberFormat("pt-BR", {
    style: "percent",
    currency: "BRL",
    minimumFractionDigits: 2,
});

Vue.filter("date", function (value: any) {
    if (value != 0 && !value) return "";
    else {
        return moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
    }
});

Vue.filter("dateTime", function (value: any) {
    if (value != 0 && !value) return "";
    else {
        return moment(value, "YYYY-MM-DD hh:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    }
});

Vue.filter("toCurrency", function (value: any) {
    if (value != 0 && !value) return "";
    else {
        return realFormater.format(value);
    }
});
Vue.filter("toPercent", function (value: any) {
    if (value != 0 && !value) return "";
    else {
        return percFormater.format(value);
    }
});

Vue.mixin({
    methods: {
        $showAlertModal(msg) {
            VuedalsBus.$emit("new", {
                component: Modal,
                props: {
                    msg: msg,
                    type: "warning",
                },
            });
        },
        $showErrorModal(msg) {
            VuedalsBus.$emit("new", {
                component: Modal,
                props: {
                    msg: msg,
                    type: "error",
                },
            });
        },
        $showSuccessModal(msg) {
            VuedalsBus.$emit("new", {
                component: Modal,
                props: {
                    msg: msg,
                    type: "success",
                },
            });
        },
    },
});

Vue.use(ConfirmationService);


Vue.use(PiniaVuePlugin);
const pinia = createPinia();

new Vue({
    el: "#app",
    router: router,
    render: (h) => h(App),
    pinia,
});
